// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sign[data-v-4b386ed6]{margin-bottom:1.041667rem;display:flex;justify-content:space-between}.sign img[data-v-4b386ed6]{width:1.041667rem;height:1.041667rem}.insilde[data-v-4b386ed6]{height:36.458333rem;display:flex;flex-flow:column}", ""]);
// Exports
module.exports = exports;
